module.exports = __webpack_public_path__ + "img/00008.50d7633c.webp";